/**
 * Date Formatter Utils
 * 날짜 형식 변환 유틸리티
 */

/**
 * 날짜 배열을 문자열로 변환
 * @param dateArray [년, 월, 일, 시, 분, 초] 형식의 배열
 * @returns YYYY-MM-DD HH:mm:ss 형식의 문자열
 */
export const formatDateArray = (dateArray: number[] | null): string => {
    if (!dateArray || dateArray.length < 6) return '-';

    const [year, month, day, hour, minute, second] = dateArray;
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(second)}`;
};

/**
 * Date 객체를 YYYY-MM-DD HH:mm:ss 형식으로 변환
 * @param date Date 객체
 */
export const formatDateTime = (date: Date): string => {
    const pad = (n: number) => String(n).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hour = pad(date.getHours());
    const minute = pad(date.getMinutes());
    const second = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};
